// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/screens/TransactionalLedger/index.css
// module id = 3090
// module chunks = 0